const useBrowserType = () => {
  const isSafari = !!(
    navigator.vendor &&
    navigator.vendor.indexOf("Apple") > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf("CriOS") === -1 &&
    navigator.userAgent.indexOf("FxiOS") === -1
  );
  const firefoxAgent = navigator.userAgent.search("Firefox");
  const chromeAgent = navigator.userAgent.search("Chrome");

  return { isChrome: chromeAgent > -1, isSafari, isFirefox: firefoxAgent > -1 };
};

export default useBrowserType;
